exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".general-actions__row{align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-left:-8px;margin-right:-8px}.general-actions__row button{padding:8px 8px 4px}.general-actions__pin[disabled]{opacity:0.5;cursor:not-allowed}@media print{.general-actions__row{display:none}}\n", ""]);

// exports
exports.locals = {
	"general-actions__row": "general-actions__row",
	"general-actions__pin": "general-actions__pin"
};